module.exports = __webpack_public_path__ + "media/private_show_request-8b38087b1877d9a817eceb4104681a3a.mp3";